import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';

const sdo = {
  namespace: sdoNs.LAYOUT,
  mutations: {


    /**
     *
     * @return {Object}
     */
    init() {
      return {
        overlay: false,
        showMenu: false
      };
    },
  },
  decorators: []
};

storeInstance.addState(sdo);
